function offsetCoordinates(e, ancestorRef) {
  let z = e;
  let x = 0;
  let y = 0;
  let c;
  while (z) {
    c = window.getComputedStyle(z, null);
    x += z.offsetLeft + (c ? parseInt(c.getPropertyValue('border-left-width'), 10) : 0);
    y += z.offsetTop + (c ? parseInt(c.getPropertyValue('border-top-width'), 10) : 0);
    z = z.offsetParent;
  }
  if (ancestorRef) {
    const aCoord = offsetCoordinates(ancestorRef);
    return { left: x - aCoord.left, top: y - aCoord.top };
  }
  return { left: x, top: y };
}

const getClosestScrollItem = ({ mainElt, getScrollItems }) => {
  const top = mainElt.scrollTop;
  let closestBefore;
  let closestBeforeDiff;
  let closestAfter;
  let closestAfterDiff;
  const scrollItems = getScrollItems(mainElt);
  scrollItems.forEach((si) => {
    const coord = offsetCoordinates(si, mainElt);
    // console.log(`${si.scrollItem.id} => ${coord.top}`);
    const diff = coord.top - top;
    // When zooming pages, positions are no more round numbers
    if (Math.abs(diff) < 2) {
      // console.log(`   Found ${si.scrollItem.id}`);
      closestBefore = si;
      closestBeforeDiff = 0;
    } else if (diff > 0) {
      if ((!closestAfter) || (closestAfterDiff > diff)) {
        closestAfter = si;
        closestAfterDiff = diff;
      }
    } else if ((!closestBefore) || (closestBeforeDiff < diff)) {
      closestBefore = si;
      closestBeforeDiff = diff;
    }
  });
  if (Math.abs(mainElt.scrollHeight - top - mainElt.clientHeight) < 2) {
    if (closestAfter) return closestAfter;
  }
  return closestBefore || closestAfter;
};

const updateMenuSelection = ({ menuElt, mainElt, getScrollItems, makeMenuId }) => {
  const closestScollItem = getClosestScrollItem({ mainElt, getScrollItems });
  const menuId = closestScollItem && makeMenuId(closestScollItem.id);
  const menuItem = menuId && document.getElementById(menuId);
  if (menuItem) {
    const sels = menuElt.getElementsByClassName('Mui-selected');
    while (sels.length > 0) {
      sels[0].classList.remove('Mui-selected');
    }
    menuItem.classList.add('Mui-selected');
  }
};

const scrollTo = (section, mainElt) => {
  const coord = offsetCoordinates(section, mainElt);
  mainElt.scrollTop = coord.top;
};

export { updateMenuSelection, getClosestScrollItem, scrollTo };
